/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import React from "react";
import PropTypes from "prop-types";
import Button from "../../../common/core/Button";
import Modal from "../../../common/core/Modal";
import ModalHeader from "../../../common/core/ModalHeader";
import ModalBody from "../../../common/core/ModalBody";
import ModalFooter from "../../../common/core/ModalFooter";
import Form from "../../../common/core/Form";
import Alert from "../../../common/core/Alert";
import Spinner from "../../../common/core/Spinner";

const DeleteSeason = (props) => {
  const {
    season,
    deteleModal,
    handleDeleteConfirmationModal,
    cancelConfirm,
    handleDeleteSeason,
    deleteSeasonInProgress,
    message,
  } = props;

  return (
    <>
      <Modal
        isOpen={deteleModal}
        toggle={() => handleDeleteConfirmationModal(season)}
        centered
        backdrop="static"
      >
        <ModalHeader toggle={cancelConfirm}>Delete Season</ModalHeader>
        {deleteSeasonInProgress
          ? (
            <div className="d-flex align-items-center justify-content-center">
              <Spinner />
            </div>
          )
          : (
            <>
              {
                message && message.type === "warning" && (
                  <Alert color={message.type}>
                    {message.message}
                  </Alert>
                )
              }
            </>
          )}
        <ModalBody>
          <Form>
            <p className="mb-4 text-center">
              Do you really want to delete the season
              <br />
              {season && season.seasonName && (
                <>
                  <span className="fw-bold pt-2 d-inline-block">{season.seasonName}</span>
                </>
              )}
              ?
            </p>
            <ModalFooter>
              <Button color="primary" className="btn-radius" onClick={() => handleDeleteSeason(season.id)}>Yes</Button>
              <Button color="light" className="btn-radius" onClick={cancelConfirm}>No</Button>
            </ModalFooter>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};

DeleteSeason.propTypes = {
  season: PropTypes.objectOf(PropTypes).isRequired,
  deteleModal: PropTypes.bool.isRequired,
  handleDeleteConfirmationModal: PropTypes.func.isRequired,
  cancelConfirm: PropTypes.func.isRequired,
  handleDeleteSeason: PropTypes.func.isRequired,
  deleteSeasonInProgress: PropTypes.bool.isRequired,
  message: PropTypes.objectOf(PropTypes.any).isRequired,
};
export default DeleteSeason;
